import AppLoadingButton from "@/components/mui/LoadingButton";
import API from "@/constant/API";
import { DEFAULT_FIAT_CURRENCY } from "@/constant/Constant";
import useToggle from "@/hook/useToggle";
import axiosInstance from "@/utils/axios";
import { Stack,Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CheckoutCounter from "../checkoutcounter/CheckoutCounter";
import DebtList from "./components/debt/DebtList";
import classes from "./css/index.module.less";

function DebtDetails() {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [paymentOrder, setPaymentOrder] = useState(null);

  const {
    toggle: showCheckCounter,
    onToggle: onToggleShowCheckCounter,
  } = useToggle(false);

  useEffect(() => {
    _initData();
  }, []);

  const _initData = async () => {
    const res = await axiosInstance.post(API.DEBT_DETAIL, {
      currency: DEFAULT_FIAT_CURRENCY,
    });
    setData(res);
  }

  const _onOrderDebt = async () => {
    setLoading(true);
    try {
      const order = await axiosInstance.post(API.DEBT_CREATE_ORDER, {
        varietyCode: data.oriCurrency,
        amount: Math.abs(data.oriDebtAmount),
      });
      
      // 打开收银台
      setPaymentOrder({
        sn: order.sn,
        bizType: 'debt',
        varietyCode: order.billCurrency,
        amount: order.billAmount,
        payAmount: order.billAmount,
      });
      onToggleShowCheckCounter();
    } finally {
      setLoading(false);
    }
  }

  const _onPaymentSuccess = () => {
    onToggleShowCheckCounter();
    _initData();
  }

  if (!data) return null;

  return (
    <Box className={'container-wrap'}>
      <div className={'small'}>{t('total_debt')}</div>
      <Stack direction={'row'} justifyContent="space-between" alignItems={'center'}>
        <Stack>
          <div className={'h3'}>$ {data.debtAmount ?? '0.00'}</div>
          <div className={'text-primary'}>≈{data.oriDebtAmount ?? '0.00'} {data.oriCurrency?.toUpperCase() ?? DEFAULT_FIAT_CURRENCY}</div>
        </Stack>
        <AppLoadingButton
          allrounded
          loading={loading}
          variant="contained"
          size="small"
          onClick={_onOrderDebt}>
          {t('repayment')}
        </AppLoadingButton>
      </Stack>
      
      <div className={classes['debt-alert']}>{t('your_account_is_in_arrears')}</div>
      <Box className={classes['debit-record-wrap']}>
        <div className={classes['debit-record-title']}>{t('debit_record')}</div>
        {!data.billList.length ? <div>{t('no_data')}</div> : <DebtList list={data.billList} />}
      </Box>

      <CheckoutCounter open={showCheckCounter} onClose={onToggleShowCheckCounter} 
        paymentOrder={paymentOrder} onSuccess={_onPaymentSuccess} />
    </Box>
  )
}

export default DebtDetails
